import { Injectable } from '@angular/core';
import { HubManager } from 'src/app/pages/hubs/common/HubManager';
import { BehaviorSubject } from 'rxjs';
import { WebStorageService } from './webstorage.service';
declare let $: any;
@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(
    private webStorageService: WebStorageService,
    private hubManager: HubManager
  ) {
    const user: any = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.setUserData(user);
  }
 
  clientAbbr: any = null;
  clientShortName = null;
  clientFullName = null;
  clientAttrs = {};
  clientID = null;
  avatarLocation = '';
  accessibleClients = [];
  logoutProcessing = false;
  serverSyncProps = {};
  whatsNewHTML = null;
  version = null;
  sharedApplicationKey = null;
  restartForced = false;
  DefaultPhoneClient = null; //ONV-1218- Code changes done by 288293
    isHubManagerCalled: boolean = true;
    ClientAbbreviation: any = '';
  Roles = [{ ClientUser: 4 }, { GlobalUser: 4 }, { ClientAdmin: 5 }, { GlobalAdmin: 6 }];

  setUserData(user: any) {
    this.clientAbbr = user ? user.ClientAbbreviation : null;
    this.clientShortName = user ? user.ClientShortName : null;
    this.clientFullName = user ? user.ClientFullName : null;
    this.clientAttrs = user ? user.ClientAttrs : null;
    this.clientID = user ? user.ClientID : null;
    this.avatarLocation = user ? encodeURI(user.AvatarLocation) : '';
    this.accessibleClients = user ? user.AccessibleClients : null;
    this.whatsNewHTML = user ? user.WhatsNewHTML : null;
    this.version = user ? user.Version : null;
      this.DefaultPhoneClient = user ? user.DefaultPhoneClient : null; //ONV-1218- Code changes done by 288293(Sadhesh)
      this.setclientAbbr(this.clientAbbr);
      //try {
      //   // $.connection.hub.state = 4;
      //    this.hubManager.eAppWillCloseHandler();
      if (!this.getHubManagerCalledStatus()) {
          this.hubManager.eAppWillCloseHandler();
          this.hubManager.setTMHubJoinedStatus(false);
          this.hubManager.setIsHubStarted(false);
          this.setHubManagerCalledStatus(true);
       }
      //}
      //catch (e) {

      //}
    if (user != null) {
      if (user.User?.FirstName) {
        const userLoginDet: { key: string; value: string }[] = [
          { key: 'ClientShortName', value: user.ClientShortName },
          { key: 'Username', value: user.User.FirstName },
          { key: 'UserEmail', value: user.User.Email },
          { key: 'UserID', value: user.User.UserID },
          ];

          /*if (!this.getHubManagerCalledStatus()) {*/
             // this.hubManager.CallHubManager(userLoginDet);
          this.hubManager.setIsHubStarted(true);
          this.hubManager.start(userLoginDet).then(() => {
              console.log('SignalR connection established successfully!');
              // You can now interact with the hub, e.g., call server methods
              // this.signalrService.invokeServerMethod('SendMessage', 'Hello from Angular!');
          })
          //this.hubManager.SetUserDetails(userLoginDet);
          //    this.setHubManagerCalledStatus(true);
          //}
      } else {
        const userLoginDet: { key: string; value: string }[] = [
          {
            key: 'ClientShortName',
            value: this.webStorageService.getItemFromSessionStorage('company'),
          },
          { key: 'Username', value: user.FirstName },
          { key: 'UserEmail', value: user.Email },
          { key: 'UserID', value: user.UserID },
        ];
          /*if (!this.getHubManagerCalledStatus()) {*/
             // this.hubManager.CallHubManager(userLoginDet);
          //this.hubManager.SetUserDetails(userLoginDet);
          this.hubManager.setIsHubStarted(true);
          this.hubManager.start(userLoginDet).then(() => {
              console.log('SignalR connection established successfully!');
              // You can now interact with the hub, e.g., call server methods
              // this.signalrService.invokeServerMethod('SendMessage', 'Hello from Angular!');
          })
          //    this.setHubManagerCalledStatus(true);
          //}
      }
    }
  }
  getUserData() {}

  validateGrant(grant: string) {
    const user: any = this.webStorageService.getItemFromSessionStorage('currentUser');
    let isValid = false;
    if (!user) return false;
    if (user.GlobalRole.Grants)
      for (var i = 0, l = user.GlobalRole.Grants.length; i < l; i++)
        if (user.GlobalRole.Grants[i].Name == grant) isValid = true;
    if (!isValid && user.Grants)
      for (var i = 0, l = user.Grants.length; i < l; i++) if (user.Grants[i].Name == grant) isValid = true;
    return isValid;
  }

  validateRole(role: number) {
    const user: any = this.webStorageService.getItemFromSessionStorage('currentUser');
    if (!user) return false;
    const roleVal = this.Roles[user.GlobalRole.Name];
    if (!roleVal) return false;
    return roleVal >= this.Roles[role];
    }

    getHubManagerCalledStatus() {
        return this.isHubManagerCalled;
    }
    setHubManagerCalledStatus(val: boolean) {
        this.isHubManagerCalled = val;
    }

    getclientAbbr() {
        return this.ClientAbbreviation;
    }
    setclientAbbr(val: boolean) {
        this.ClientAbbreviation = val;
    }
}
